module.exports = __webpack_public_path__ + "img/202412_skincareoil_voice.2443f3cb.jpg";